import { Component, Input } from '@angular/core';
import { OwnedStateResource, StateResource } from '@schir-int-client/ngrx-helpers';

@Component({
	selector: 'schir-int-client-spinner',
	templateUrl: './spinner.component.html',
	styleUrls: ['./spinner.component.scss'],
	standalone: false,
})
export class SpinnerComponent {
	@Input({ required: true }) stateResource: StateResource<any> | OwnedStateResource<any>;
	@Input() diameter: number = 70;

	get showSpinner(): boolean {
		return this.stateResource ? this.stateResource.loading : false;
	}
}
